import { render } from "./CreateBusinessDirectoryModal.vue?vue&type=template&id=2afdaf4a"
import script from "./CreateBusinessDirectoryModal.vue?vue&type=script&lang=js"
export * from "./CreateBusinessDirectoryModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__